<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/179iOxP/tc-custom/9781497631724.jpg?1733029640069" alt="This image is the cover for the book Heaven on Earth"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heaven on Earth
      </h1>
      <p class="bookDescription body article font2">
        <b>A journey into the past. An angelic hero. A divine romance from the <i>New York Times</i>–bestselling author who “proves that love is timeless” (Nora Roberts). </b><br/><br/> Working in the accounting department of a large soap manufacturer isn’t exactly where Casey O’Reilly saw her life as going. She had always pictured something more glamorous, more exciting. But, she never pictured something so exciting as time travel.<br/><br/> A freak lightning strike near Sante Fe somehow sends Casey back to the year 1878. Thrown into vibrant yet unfamiliar past, Casey finds herself lost and alone. That is, until a mysterious man named Luke arrives, claiming to be a time traveler himself. He wants to guide Casey on her journey, even arranging for her to be the guest of an aristocratic Hispanic family. Will Casey be able to handle the shock of traveling back in time? Will she finally take control of her life and realize that love is staring her right in the face?<br/><br/> In <i>Heaven on Earth</i>, Constance O’Day-Flannery, the original “Queen of Time Travel Romance,” shows readers that true love can lead us toward our destinies... even if those destinies are lifetimes apart. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Constance O'Day-Flannery
      </h2>
      
      <p class="authorDescription body article">Constance O&rsquo;Day-Flannery, the mother of two children, took up writing when her children started school and she had spare time to do what she had wanted to do for a long time. She has never taken a writing course and her inspiration came from reading romance novels during a period of recovery from surgery. She let her imagination take over and wrote her first novel in about a year and a half. In the process, she created an entirely new genre of romance novel, the time travel romance, one of the early variations of paranormal romance, and she quickly became a huge success. She has published more than twenty novels, and each and every one has appeared on national bestseller lists. She received the Romantic Times Book Club Award for Best Time Travel for&#160;<I>Timeswept Lovers</I>&#160;and the Romantic Times Book Club Award for Best Contemporary Fantasy Romance for&#160;<I>Second Chances</I>. In 2001, she moved to Ireland and spent several years living there. Eventually, she moved back to the United States and lived in Pennsylvania for several years before moving to the Atlantic coast region of southern New Jersey.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6644eada